<!--
 * @Author: DY
 * @Date: 2024-11-21 14:41:15
 * @LastEditTime: 2024-12-11 15:13:32
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\storage\monitorTheInventoryConfirm\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="monitorTheInventoryConfirm commonListStyles">
            <HeaderNav
                header-title="监盘确认列表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <div class="queryCriteria">
                    <div class="queryItem queryTime" @click="selectDate">
                        <div class="queryTimeItem">
                            <van-icon name="notes-o"></van-icon>
                            <span>{{ startTimeValue }}</span>
                        </div>
                        <p>—</p>
                        <div class="queryTimeItem">
                            <van-icon name="notes-o"></van-icon>
                            <span>{{ endTimeValue }}</span>
                        </div>
                    </div>
                    <div class="queryItem queryDropdown">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="statusVal" :options="statusOption" @change="onRefresh"></van-dropdown-item>
                        </van-dropdown-menu>
                    </div>
                    <div class="queryItem queryDropdown">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="differIsZeroVal" :options="differenceOption" @change="onRefresh"></van-dropdown-item>
                        </van-dropdown-menu>
                    </div>
                </div>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo" @click="openConfirmForm(item)">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">盘点单编号：{{ item.CheckNo }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>库位编码：{{ item.GridCode }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>库位名称：{{ item.GridName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.StockName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.MaterialCodes }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料短描述：{{ item.MaterialShortNames }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_2@2x.png" alt="">
                                            <span>单位：{{ item.Unit }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>盘点前库存：{{ item.VolumeCurrent }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>盘点后库存：{{ item.VolumeCheck }}</span>
                                        </p>
                                        <!-- <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>最大库存：{{ item.VolumeMax }}</span>
                                        </p> -->
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>期间入库：{{ item.DuringInStockVolume }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>期间出库：{{ item.DuringOutStockVolume }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>盘点差异：{{ item.VolumeDiffer }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>盘点人：{{ item.CheckUserName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>盘点时间：{{ item.CheckTime }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn">
                                        <button>{{ item.Status == 1 ? '审核' : '查看' }}</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-calendar
                type="range"
                v-model="showCalendar"
                :min-date="minDate"
                :default-date="defaultDate"
                @confirm="confirmSelectDate"
            ></van-calendar>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'monitor-the-inventory-confirm',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'monitor-the-inventory-confirm');
        }
        next();
    },
    data() {
        return {
            startTimeValue: '',
            endTimeValue: '',
            showCalendar: false,
            defaultDate: [],
            minDate: new Date(2000, 0, 1),
            requestUrl: '/procurement/stock_grid_check/monitor_inventory_page',
            initIndex: 1,
            pageIndex: 1,
            indexKey: 'PageIndex',
            sizeKey: 'PageSize',
            statusVal: 1,
            statusOption: [
                // { text: '盘点中', value: 0 },
                { text: '已提交', value: 1 },
                // { text: '已退回', value: 2 },
                { text: '已确认', value: 3 },
            ],
            differIsZeroVal: null,
            differenceOption: [
                { text: '全部', value: null },
                { text: '差异为0', value: true },
                { text: '差异不为0', value: false },
            ],
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        const dates = currencyFun.getMonthData();
        this.startTimeValue = dates.startDate;
        this.endTimeValue = dates.endDate;
    },
    mounted() {},
    methods: {
        loadRequestData() {
            return {
                CheckTimeMin: this.startTimeValue,
                CheckTimeMax: this.endTimeValue,
                Status: this.statusVal,
                DifferIsZero: this.differIsZeroVal,
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                SearchKey: this.keyVal,
            };
        },
        selectDate() {
            this.defaultDate = [new Date(this.startTimeValue), new Date(this.endTimeValue)];
            this.showCalendar = true;
        },

        confirmSelectDate(val) {
            this.startTimeValue = currencyFun.timeFormat(new Date(val[0]), 'yyyy-MM-dd');
            this.endTimeValue = currencyFun.timeFormat(new Date(val[1]), 'yyyy-MM-dd');
            this.showCalendar = false;
            this.onRefresh();
        },

        openConfirmForm(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'monitorTheInventoryConfirmForm', params: { type: 'maintain', data: item } });
        },
    },
};
</script>
<style lang="stylus">
.monitorTheInventoryConfirm
    section
        .queryCriteria
            display: flex
            flex-wrap: wrap
            justify-content space-between
            .queryItem
                &.queryDropdown
                    width calc(50% - 5rpx)
                    margin-top: 10rpx
        .van-pull-refresh
            height: calc(100% - 135rpx) !important
</style>
